module.exports = __webpack_public_path__ + "media/images/iconTrendUp__inactive-b2f9db5385711234c52722aa7578e987.png";